import React from "react";
import "./Parts.css";
import partPhoto from "../../1000035459.jpg";

function Parts() {
    return (
        <div className="parts-page">
            <main className="parts-hero">
                <div className="hero-content">
                    <h1 className="hero-title">Genuine Quality, Unbeatable Value</h1>
                    <p className="hero-subtitle">
                        Find the exact replacement part you need. We stock a huge range of fully tested, high-quality used parts for various Renault makes and models.
                    </p>
                    <a
                        href="https://www.ebay.co.uk/str/kriscars4ltd"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-primary hero-btn"
                    >
                        Shop on eBay Now
                    </a>
                </div>
                <div className="hero-image-container">
                    <img src={partPhoto} alt="Car Parts" />
                </div>
            </main>

            <section className="features-section">
                <div className="features-grid">
                    <div className="feature-item">
                        <div className="feature-icon">✅</div>
                        <h3>Rigorously Tested</h3>
                        <p>Every part is tested for full functionality and reliability before it's listed for sale.</p>
                    </div>
                    <div className="feature-item">
                        <div className="feature-icon">🚚</div>
                        <h3>Fast & Secure Shipping</h3>
                        <p>We pack every item carefully and ship it quickly so you can get back on the road sooner.</p>
                    </div>
                    <div className="feature-item">
                        <div className="feature-icon">🤝</div>
                        <h3>Trusted Seller</h3>
                        <p>With hundreds of positive reviews, you can buy with complete confidence from our eBay store.</p>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default Parts;